import styled from '@emotion/styled';
import { getDefaultTextProps } from '../Text/styles.shared.ts';
import { getColor, getSpace } from '../../utils/index.ts';
import { EmotionInputViewProps } from './types.ts';

export const TextInput = styled.input<EmotionInputViewProps>`
  position: relative;
  display: block;
  width: inherit;
  border-radius: 4px;
  outline: none;
  border-width: 2px;
  border-style: solid;
  border-color: ${getColor('pink')};
  border-radius: 15px;
  padding: ${getSpace('6')} ${getSpace('32')} ${getSpace('6')} ${getSpace('12')};
  ${getDefaultTextProps({ size: 14 })};

  &::placeholder {
    color: ${getColor('white-primary')};
  }

  &:hover,
  &:focus {
    border: 2px solid ${getColor('pink')};
    box-shadow: 0 0 5px 1px ${getColor('main-deep-2')};
  }

  ${({ error }) =>
    error &&
    `
    color: ${getColor('error-deep-3')};
    border-color: ${getColor('error-deep-3')};
    box-shadow: 0px 0px 5px 1px ${getColor('error-deep-3')};

    &:focus,&:hover {
      border-color: ${getColor('error-deep-3')};
      box-shadow: 0px 0px 5px 1px ${getColor('error-deep-3')};
    }

    &::placeholder {
      color: ${getColor('error-deep-3')};
    }
  `}

  &:disabled {
    background-color: ${getColor('gray-deep-1')};
    cursor: not-allowed;
    color: ${getColor('gray-deep-3')};
    border-color: ${getColor('gray-deep-2')};
    pointer-events: none;

    &::placeholder {
      color: ${getColor('gray-deep-2')};
    }
  }
`;
